import { render, staticRenderFns } from "./EnfrcTable.vue?vue&type=template&id=68c9d445"
import script from "./EnfrcTable.vue?vue&type=script&lang=ts"
export * from "./EnfrcTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports